import * as React from "react";
import { observer } from "mobx-react";
import { Button } from "./Button";
import { Strings } from "../Stores/StringsStore";

@observer
export class Hamburger extends Button {

	render() {
		return <Button {...this.props} title={this.props.title ? this.props.title : Strings.appNavigation.mainNavigationButtonTooltip}>
			<i className="icon--menu">
				<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">

					<rect y="14" width="32" height="4" />
					<rect y="2" width="32" height="4" />
					<rect y="26" width="32" height="4" />

				</svg>
			</i>
		</Button>;
	}
}
